import React, { createContext } from "react";

import "./Address.css";
// import pict1 from "../../images/pict1.png";
// import pict2 from "../../images/pict2.png";
// import pict3 from "../../images/pict3.png";
// import pict4 from "../../images/pict4.png";

function Address() {
  return (
    <div className="address">
		<nav className="Scroll_Wrapper">
			{/* <figure className="Item">
				<img src={pict1} alt="Poster Number 1" />
				<figcaption className="Caption">1</figcaption>
			</figure> */}
			<figure className="Item">
				{/* <img src={pict2} alt="Poster Number 2" /> */}
				<figcaption className="Caption">2</figcaption>
			</figure>
			<figure className="Item">
				{/* <img src={pict3} alt=" Poster Number 3" /> */}
				<figcaption className="Caption">3</figcaption>
			</figure>
			<figure className="Item">
				{/* <img src={pict4} alt="Poster Number 4" /> */}
				<figcaption className="Caption">4</figcaption>
			</figure>
		</nav>
    </div>
  );
}

export default Address;
